<script setup>
import { ArrowRightIcon } from "@heroicons/vue/20/solid"
</script>

<template>
  <section>
    <div
      class="flex flex-col sm:flex-row mt-8 mb-8 items-center justify-center space-y-4 sm:space-y-0"
    >
      <!-- Roof CTA -->
      <router-link :to="{ name: 'LeadFlow' }" class="cta-overlay roof-cta">
        <div class="cta-content">
          <h3 class="text-xl font-bold mb-2">
            Découvrez votre potentiel solaire
          </h3>
          <p class="text-sm">
            Calculez la valeur énergétique, économique et environnementale de
            votre gisement solaire.
          </p>
        </div>
        <ArrowRightIcon class="cta-arrow w-8 h-8" />
      </router-link>

      <!-- Software CTA -->
      <router-link :to="{ name: 'LeadFlow' }" class="cta-overlay software-cta">
        <div class="cta-content">
          <h3 class="text-xl font-bold mb-2">Analyser votre consommation</h3>
          <p class="text-sm">
            Calculez vos économies sur facture d’énergie en étudiant les données
            du compteur Linky d’Enedis.
          </p>
        </div>
        <ArrowRightIcon class="cta-arrow w-8 h-8" />
      </router-link>
    </div>
  </section>
</template>

<style scoped>
.cta-overlay {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 250px;
  color: #fff;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  transition: background-color 0.3s ease;
  border-radius: 0.5rem;
}

.cta-overlay::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease;
}

.cta-overlay:hover::before {
  background-color: rgba(0, 0, 0, 0.5); /* dark overlay on hover */
}

.cta-content {
  position: relative;
  z-index: 10;
  color: #fff;
  width: 80%;
}
.cta-arrow {
  position: absolute;
  bottom: 1rem;
  right: 6rem;
  transition: transform 0.3s ease;
}

.roof-cta {
  background-image: url("https://images.ctfassets.net/1b6f0wuf6ave/7y3h1Z3VLLNZq4SM1r0PwW/9ca90cdf7599f8fd393caf9e6228ce9e/roof.png");
  clip-path: polygon(0 0, 90% 0, 100% 50%, 90% 100%, 0 100%);
  padding: 1.5rem 4rem 1.5rem 1.5rem;
}

.software-cta {
  background-image: url("https://images.ctfassets.net/1b6f0wuf6ave/7Ky3ZwIMFdxTWyyTJ5ELrL/423ee3c02fca243ed6dbeabce015e3cf/software.png");
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%, 10% 50%);
  padding: 1.5rem 1.5rem 1.5rem 4rem;
}

.cta-overlay:hover .cta-arrow {
  transform: translateX(10px);
}
</style>
